import customAlert from "./customAlert";
import getCookie from "./getCookie";


let handling401 = false;

export default async function api(
  input: RequestInfo | URL,
  init: RequestInit & { skip401?: boolean } = {}
) {
    const method = init.method?.toUpperCase() ?? "GET";

    // dev base URL
    if (process.env.NODE_ENV === "development") {
        const baseUrl = process.env.NEXT_PUBLIC_API_BASE as string;
        input = baseUrl + input
    }

    // 🔧 headers를 실제 Headers 인스턴스로 정규화
    const headers = new Headers(init.headers);

    // 공통 옵션
    const baseInit: RequestInit = {
        ...init,
        method,
        credentials: "include",
        headers, // ← Headers 객체 그대로 전달
    };

    // 쓰기 메서드면 CSRF 헤더 추가
    if (["POST", "PATCH", "PUT", "DELETE"].includes(method)) {
        const csrftoken = getCookie("csrftoken");
        if (csrftoken) headers.set("X-CSRFToken", csrftoken);
    }
    // GET이고 호출부에서 cache 미지정 시에만 no-store 부여 (기존 호출부 영향 최소화)
    else if (method === "GET" && init.cache === undefined) {
        baseInit.cache = "no-store";
    }

    const res = await fetch(input, baseInit);

    // 중앙에서 401 처리
    if (res.status === 401 && !init.skip401) {
    // if (res.status === 401) {
        if (typeof window === "undefined") throw res;

        // 중복 얼럿 방지
        if (!handling401) {
            handling401 = true;
            try {
                const getLocale = getCookie("lang") ?? "ko"
                let duplicateLoginMessage = "다른 곳에서 로그인되어 자동 로그아웃되었습니다."
                if(getLocale == "en"){
                    duplicateLoginMessage = "You have been logged out due to another login."
                }
                await customAlert(duplicateLoginMessage, "warning");
                try { sessionStorage.setItem('logoutInitiatedByUser', '1'); } catch (e) { /* ignore */ }

                // 확인 후 새로고침
                location.reload();
            } finally {
                handling401 = false;
            }
        }
        throw res;
    }else if(res.status === 401 && init.skip401){
        // 401스킵하면 자동 리로드하면서 로그아웃 처리
        location.reload()
    }


    if (!res.ok) throw res;
    return res;
}